/**
 * Cleans href or src value so it only allows http and mailto
 *
 * @param linkOrSrc
 * @returns
 */
function cleanLinkSrc(linkOrSrc) {
  if (!/^(http|https|mailto):\/\//.test(linkOrSrc)) {
    return '';
  }
  return linkOrSrc;
}

export default cleanLinkSrc;
